const convertDosageUnit = (dosage) => {
  if (!dosage) return dosage;

  const low = dosage.toLowerCase();

  // If the dosage contains a '/' slash, it's a ratio or combination format
  // (e.g. "80/4.5 mcg", "400/12 mcg (320/9)", "100 mcg/25 mcg", "Diskus 100 mcg/50 mcg")
  // Do NOT try to convert these — display the original string as-is.
  if (dosage.includes("/")) {
    return dosage;
  }

  // Check if dosage contains a range like '24,000-26,000 mcg' (case insensitive)
  if (low.includes("mcg") && dosage.includes("-")) {
    // Extract numeric values around the dash
    const match = dosage.match(/([\d,]+(?:\.\d+)?)\s*-\s*([\d,]+(?:\.\d+)?)/);
    if (match) {
      const v1 = parseFloat(match[1].replace(/,/g, ""));
      const v2 = parseFloat(match[2].replace(/,/g, ""));
      if (v1 >= 1000 && v2 >= 1000) {
        return ` ${v1 / 1000} mg - ${v2 / 1000} mg`;
      }
      return dosage;
    }
  }

  // Check if dosage contains 'mcg' (case insensitive) — simple single value
  if (low.includes("mcg")) {
    // Extract only the FIRST numeric value (before any slash or extra text)
    const match = dosage.match(/([\d,]+(?:\.\d+)?)/);
    if (match) {
      const numericValue = parseFloat(match[1].replace(/,/g, ""));
      if (numericValue >= 1000) {
        const convertedValue = numericValue / 1000;
        return ` ${convertedValue} mg`;
      }
      return dosage;
    }
  }

  // Return original if not mcg
  return dosage;
};

export { convertDosageUnit };